/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Item_RequiredInputs */

const en_task_flow_item_required = /** @type {(inputs: Task_Flow_Item_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required to complete`)
};

const pt_br2_task_flow_item_required = /** @type {(inputs: Task_Flow_Item_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigatório para concluir`)
};

/**
* | output |
* | --- |
* | "Required to complete" |
*
* @param {Task_Flow_Item_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_item_required = /** @type {((inputs?: Task_Flow_Item_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Item_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_item_required(inputs)
	return pt_br2_task_flow_item_required(inputs)
});